import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/society.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import CompleteModal from '@/components/common/Modal/CompleteModal/CompleteModal';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import TabList from '@/components/common/Tab/TabList/TabList';
import AbstractConfirm from '@/components/Society/AbstractConfirm/AbstractConfirm';
import AbstractGuide from '@/components/Society/AbstractGuide/AbstractGuide';
import SocietyConfirm from '@/components/Society/SocietyConfirm/SocietyConfirm';
import SocietyGuide from '@/components/Society/SocietyGuide/SocietyGuide';
import SocietyRegister from '@/components/Society/SocietyRegister/SocietyRegister';
import {
	normalizeSocietyMenu,
	normalizeSocietyStep,
	SOCIETY_MENU_ABSTRACT,
	SOCIETY_MENU_GUIDE,
	SOCIETY_MENU_REGISTER,
	SOCIETY_STEP_ABSTRACT_CONFIRM,
	SOCIETY_STEP_REGISTER_CONFIRM,
} from '@/constants/society';
import { useModalStore } from '@/store/modalStore';

const menuList = [SOCIETY_MENU_GUIDE, SOCIETY_MENU_ABSTRACT, SOCIETY_MENU_REGISTER];

const Society = () => {
	const { t } = useTranslation();
	const location = useLocation();
	const navigate = useNavigate();

	const { showModal } = useModalStore();
	const [searchParams] = useSearchParams();
	const [isOpen, setIsOpen] = useState(false);
	const params = normalizeSocietyMenu(location.state?.menu);
	const stepParams = normalizeSocietyStep(location.state?.step);
	const successParams = searchParams.get('sucess') ?? '';
	const failParams = searchParams.get('aid') ?? '';

	const handleSetMenu = (menu: string) => {
		navigate('/society', { state: { menu: menu } });
	};

	useEffect(() => {
		const menuState = { menu: params || SOCIETY_MENU_REGISTER };

		if (successParams === 'true') {
			setIsOpen(true);
			navigate('/society', { replace: true, state: menuState });
			return;
		}

		if (successParams === 'false' || failParams !== '') {
			showModal(t('common.alerts.paymentFailed'));
			navigate('/society', { replace: true, state: { menu: SOCIETY_MENU_REGISTER } });
		}
	}, [failParams, navigate, params, showModal, successParams, t]);

	return (
		<main>
			<SubBanner subTitle="society.page.bannerSubtitle" title="society.page.bannerTitle" img={mainBanner} />

			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === menuList[0] && <SocietyGuide />}
			{params === menuList[1] && stepParams !== SOCIETY_STEP_ABSTRACT_CONFIRM && <AbstractGuide />}
			{params === menuList[1] && stepParams === SOCIETY_STEP_ABSTRACT_CONFIRM && <AbstractConfirm />}
			{params === menuList[2] && stepParams !== SOCIETY_STEP_REGISTER_CONFIRM && <SocietyRegister />}
			{params === menuList[2] && stepParams === SOCIETY_STEP_REGISTER_CONFIRM && <SocietyConfirm />}

			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<CompleteModal closeModal={setIsOpen} />
					</ModalBox>
				</ModalPortal>
			)}
		</main>
	);
};

export default Society;
